<template>
    <div v-if="article.category.indexOf(category) != -1">
        <a :href="article.pdflink" class="list-title" target="_blank">
            <div class="survey-img">
                <img :src="formattedImgUrl(article.content)" />
            </div>
            <font-awesome-icon :icon="['fas', 'angle-double-right']" />
            {{ article.title }}
        </a>
        <div>
            <p class="post-time">
                <font-awesome-icon :icon="['far', 'clock']" />
                {{ formattedTimestamp(article.timestamp) }}
            </p>
        </div>
        <h3 class="content">{{ article.title_content }}</h3>

        <hr />
    </div>
</template>


<script>
import formatted from "@/mixin/formatted";

export default {
    mixins: [formatted],
    props: ["article", "category"],
};
</script>

<style scoped>
.survey-img img {
    margin-bottom: 20px;
    display: block;
    max-width: 95%;
}

.list-title {
    color: var(--blue);
    font-size: 22px;
    font-weight: 500;
    text-decoration: none;
    line-height: normal;
}

.post-time, .post-time svg {
    color: var(--black);
    font-size: 16px;
    font-weight: 300;
    margin-top: 8px;
    text-decoration: none;
    padding: 0 3px;
}

.content {
    margin: 16px 0;
    font-weight: 400;
    font-size: 16px;
    color: var(--black);
    line-height: normal;
}
</style>
